import { createHelpers } from 'vuex-map-fields'

const { getLogoField, updateLogoField } = createHelpers({
  getterType: 'getLogoField',
  mutationType: 'updateLogoField'
})

const state = {
  logoVisible: false,
  width: window.innerWidth,
  breakpoint: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  }
}

const mutations = {
  'SET_WIDTH' (state) {
    state.width = window.innerWidth
  },
  'CHANGE_VIEW' (state, coordinates) {
    window.scroll(coordinates.x, coordinates.y)
  },
  updateLogoField
}

const actions = {
  setWidth: ({ commit }) => {
    commit('SET_WIDTH')
  },
  changeView: ({ commit }, coordinates) => {
    commit('CHANGE_VIEW', coordinates)
  }
}

const getters = {
  width: state => {
    return state.width
  },
  xs: state => {
    return (state.width < state.breakpoint.sm)
  },
  sm: state => {
    return (state.width >= state.breakpoint.sm)
  },
  md: state => {
    return (state.width >= state.breakpoint.md)
  },
  lg: state => {
    return (state.width >= state.breakpoint.lg)
  },
  xl: state => {
    return (state.width >= state.breakpoint.xl)
  },
  logoVisible: state => {
    return state.logoVisible
  },
  getLogoField
}

export default {
  state,
  mutations,
  actions,
  getters
}
